var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale.client)?_c('div',{staticClass:"j-start"},[_c('b-button',{on:{"click":function($event){$event.stopPropagation();return _vm.show_current_acount.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.sale.client.name)+" ")]),_c('whatsapp-btn',{attrs:{"sale":_vm.sale}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }